import React, {Component} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes, faCaretRight, faCaretDown} from "@fortawesome/free-solid-svg-icons";
import {bsc, uniswap} from "../const";

class DisplayData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showChart: false,
        }
    }
    handleShowChart = () => {
        this.setState({
            showChart: !this.state.showChart,
        })
    }

    render() {
        const {
            isLoading,
            tokenInfo,
            tokenAddress,
            reasonForFailure,
            snipe,
            selectedOption,
            frontRun,
            selectedChain,
            symbol,
            failAmt,
        } = this.props;
        const {showChart} = this.state;
        return (
            <div>
                {
                    snipe === 'fail' && (
                        <div>
                            <p className="snipeStatusFail">
                                <FontAwesomeIcon icon={faTimes} style={{color: 'red', marginRight: '7px'}}/>
                                {selectedOption === 'buy' ? failAmt > 0 ? `Snipe failed ${failAmt} time(s)` : `Snipe Failed` : 'Sell Failed!'}
                            </p>
                            {reasonForFailure &&
                            <p className="snipeStatusFail">{reasonForFailure}</p>}
                        </div>
                    )
                }
                {
                    !isLoading && (
                        <div>
                            {tokenInfo && tokenInfo.price && tokenInfo.price.token && tokenAddress &&
                            <div>
                                <p style={{
                                    color: '#DFAE20'
                                }}>{tokenInfo.name || 'Token'} Balance: {`${parseFloat(Number(tokenInfo.balances.tokenBalance).toFixed(2)).toLocaleString('en-US')}`}
                                    <br/>
                                    {`($${tokenInfo.price.token.toLocaleString('en-US')}/${tokenInfo.price.bnbValueOfTokens} ${symbol})`}
                                </p>
                                <p style={{
                                    color: '#DFAE20'
                                }}>{tokenInfo.name || 'Token'} Market
                                    Cap: {`$${Math.ceil(tokenInfo.marketCap.usd).toLocaleString('en-US')}`}</p>
                                {selectedChain === bsc && <p style={{
                                    color: '#DFAE20',
                                }}>Poocoin Chart:
                                    {showChart &&
                                    <span><FontAwesomeIcon onClick={this.handleShowChart} icon={faCaretDown} style={{
                                        color: 'green',
                                        marginLeft: '10px',
                                        fontSize: '20px'
                                    }}/><br/><br/></span>}
                                    {!showChart &&
                                    <span><FontAwesomeIcon onClick={this.handleShowChart} icon={faCaretRight} style={{
                                        color: 'green',
                                        marginLeft: '10px',
                                        fontSize: '20px'
                                    }}/></span>}
                                    {showChart && <iframe id="inlineFrameExample"
                                                          title="Poocoin"
                                                          width="100%"
                                                          height="500px"
                                                          style={{margin: '0 auto'}}
                                                          src={`https://poocoin.app/tokens/${tokenAddress}`}>
                                    </iframe>}<br/>
                                    <p style={{marginTop: '15px'}}>Poocoin Link: <a style={{color: '#5e8ce8'}}
                                                                                    target='_blank' rel="noreferrer"
                                                                                    href={`https://poocoin.app/tokens/${tokenAddress}`}>Poocoin</a>
                                    </p>
                                </p>}
                                {selectedChain === uniswap && tokenInfo && tokenInfo.lpAddress &&
                                <p style={{marginTop: '15px'}}>Chart Link: <a style={{color: '#5e8ce8'}}
                                                                              target='_blank' rel="noreferrer"
                                                                              href={`https://www.dextools.io/app/ether/pair-explorer/${tokenInfo.lpAddress}`}>Dextools</a>
                                </p>
                                }
                            </div>
                            }
                        </div>
                    )

                }
                {
                    isLoading === true &&
                    <div>
                        <button
                            className={selectedOption === 'buy' ? 'loadingButton' : 'loadingSellButton'}
                            disabled={true}>
                            {selectedOption === 'buy' && frontRun ? 'Frontrunning' : selectedOption === 'buy' ? 'Sniping...' : 'Selling...'}
                        </button>
                        <div style={{margin: '0 auto', marginTop: '10px'}} className={'loader'}></div>
                    </div>
                }
            </div>
        )
    }
}

export default DisplayData;